export const GET_ALL_ORDERS_FAILURE = 'GET_ALL_ORDERS_FAILURE';
export const GET_ALL_ORDERS_SUCCESS = 'GET_ALL_ORDERS_SUCCESS';
export const GET_SINGLE_ORDER_SUCCESS = 'GET_SINGLE_ORDER_SUCCESS';
export const GET_SINGLE_ORDER_FAILURE = 'GET_SINGLE_ORDER_FAILURE';
